export const STATIC_CONSTANTS = {
  MARKETING_URL: 'https://www.checkmate.tech',
};
